import { DynamicDecorator } from '@natu/ui/Decorators/DynamicDecorator';

export const ModestDecorator = () => (
  <>
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-butterscotch absolute bottom-14 right-28 hidden h-6 w-6 md:block"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="absolute bottom-24 right-52 hidden h-6 w-6 text-white md:block"
    />
  </>
);
